import React from 'react';
import { Box, Container, Flex, Link, Text } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { getCopyrightText } from '@config/company';

/**
 * Footer component displayed on all pages
 * Contains copyright information and optional links
 */
const Footer = (): JSX.Element => {
    return (
        <Box
            as="footer"
            bg="principal.blue"
            color="white"
            py={6}
            width="100%"
            m={0}
        >
            <Container maxW="container.xl">
                <Flex
                    direction={{ base: 'column', md: 'row' }}
                    align="center"
                    justify="space-between"
                    gap={4}
                >
                    {/* Copyright */}
                    <Text fontSize="sm" textAlign={{ base: 'center', md: 'left' }}>
                        {getCopyrightText()}
                    </Text>

                    {/* Legal links (publicly accessible, outside auth) */}
                    <Flex gap={6} fontSize="sm">
                        <Link as={RouterLink} to="/mentions-legales" _hover={{ textDecoration: 'underline' }}>
                            Mentions légales
                        </Link>
                        <Link as={RouterLink} to="/confidentialite" _hover={{ textDecoration: 'underline' }}>
                            Politique de confidentialité
                        </Link>
                    </Flex>
                </Flex>
            </Container>
        </Box>
    );
};

export default Footer;